import { root } from './option';

export const option = {
  ...root,
};
